/**
 * Activities API - Auto-generated typed wrapper.
 * DO NOT EDIT - Regenerate with: bun run generate
 * @generated
 */

import { getActivities } from "../generated/activities/activities";

import { wrapListMethod } from "./utils";

export const activities = {
  /** @see getActivities */
  list: wrapListMethod(getActivities),
} as const;

export type ActivitiesApi = typeof activities;
